// Generated by genversion.
module.exports = '1.3.2';
